var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarExpected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_7932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_7932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2187 5.31997C13.2759 5.31997 12.3281 5.31501 11.3853 5.31997C10.9089 5.31997 10.6657 5.58298 10.6508 6.0544C10.6409 6.31244 10.6508 6.57544 10.6062 6.82852C10.5466 7.14114 10.2886 7.30986 9.96605 7.3049C9.66334 7.3049 9.40034 7.13122 9.35568 6.83348C9.22666 5.975 9.27132 5.15126 9.98093 4.51112C10.3481 4.18361 10.7799 4 11.2811 4C13.7027 4 16.1193 4 18.5409 4C19.4044 4 19.9552 4.5657 19.9552 5.42914C19.9552 9.35433 19.9552 13.2795 19.9552 17.2047C19.9552 17.8994 19.6277 18.356 18.9627 18.5793C17.6973 19.006 16.4319 19.4278 15.1616 19.8446C14.1542 20.1771 13.3156 19.5668 13.3007 18.4999C13.3007 18.3262 13.3007 18.1525 13.3007 17.949C12.6457 17.949 12.0254 17.949 11.4051 17.949C10.1893 17.949 9.32591 17.1005 9.31102 15.8798C9.31102 15.4977 9.30606 15.1106 9.31102 14.7285C9.31598 14.2571 9.58395 13.9594 9.99086 13.9643C10.3928 13.9643 10.6508 14.2621 10.6558 14.7434C10.6608 15.1354 10.6558 15.5324 10.6558 15.9294C10.6608 16.3264 10.8841 16.6043 11.2662 16.6191C11.9262 16.644 12.5911 16.6241 13.2958 16.6241V16.2371C13.2958 13.1654 13.3057 10.0888 13.2908 7.01708C13.2908 6.26281 15.4244 5.6723 16.1588 5.31997H14.2187Z",
    fill: "url(#paint0_linear_992_7932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00158 9.84553C8.00158 9.22028 8.00158 8.63473 8.00158 8.04422C8.00158 7.70182 7.93211 7.39416 7.58971 7.24529C7.24235 7.09145 6.97439 7.25521 6.73123 7.50333C5.92734 8.31218 5.11848 9.11608 4.31459 9.92493C3.89279 10.3467 3.89776 10.6742 4.31459 11.101C5.11848 11.9099 5.92734 12.7137 6.7362 13.5226C6.96943 13.7558 7.21754 13.9196 7.5649 13.7856C7.92219 13.6467 8.00655 13.3489 8.00158 13.0065C8.00158 12.4061 8.00158 11.8056 8.00158 11.1705C8.30925 11.1705 8.58714 11.1705 8.86503 11.1705C9.45554 11.1705 10.0461 11.1754 10.6366 11.1705C11.0435 11.1556 11.3164 10.8777 11.3164 10.5055C11.3164 10.1383 11.0286 9.8505 10.6366 9.84553C9.77809 9.84057 8.91465 9.84553 8.00655 9.84553H8.00158Z",
    fill: "url(#paint1_linear_992_7932)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_7932",
    x1: 14.627,
    y1: 4,
    x2: 14.627,
    y2: 19.9354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_992_7932",
    x1: 7.65825,
    y1: 7.18555,
    x2: 7.65825,
    y2: 13.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarExpected);
export default __webpack_public_path__ + "static/media/calendar_expected.5b4bcc30ab44f5ce9d974a2218941d13.svg";
export { ForwardRef as ReactComponent };